import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-be025f30")

_pushScopeId("data-v-be025f30")
const _hoisted_1 = { class: "border-0 rounded-lg shadow-lg relative flex flex-col w-full h-full bg-white outline-none focus:outline-none" }
const _hoisted_2 = { class: "flex items-center justify-between py-2 px-4 md:py-5 md:px-5 border-b border-solid border-gray-300 rounded-t" }
const _hoisted_3 = { class: "text-lg md:text-2xl font-bold" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "bg-transparent text-gray-500 h-6 w-6 text-xl block outline-none focus:outline-none" }, " × ", -1)
const _hoisted_5 = {
  key: 0,
  class: "flex items-center justify-end px-4 md:px-6 py-2 md:py-4 border-t border-solid border-gray-300 rounded-b"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      class: ["overflow-x-hidden overflow-y-auto fixed inset-0 z-30 outline-none focus:outline-none justify-center items-center flex", { 'z-45': _ctx.isOverlay }]
    }, [
      _createVNode("div", {
        class: ["relative w-full md:w-4/5 mx-6 md:mx-auto my-auto", _ctx.modalSizeCss]
      }, [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("h3", _hoisted_3, [
              _renderSlot(_ctx.$slots, "title")
            ]),
            (_ctx.showCloseButton)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  class: "p-1 ml-auto bg-transparent border-0 text-black float-right text-3xl leading-none font-semibold outline-none focus:outline-none",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                }, [
                  _hoisted_4
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", {
            class: ["relative p-6 flex-auto modal-height overflow-y-auto", {
            'overlay flex flex-col justify-center': _ctx.isOverlay,
            [_ctx.bodyBackgroundColor]: _ctx.bodyBackgroundColor,
            [_ctx.height]: _ctx.height
          }]
          }, [
            _renderSlot(_ctx.$slots, "body")
          ], 2),
          (!_ctx.hideFooter)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _renderSlot(_ctx.$slots, "footer")
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ], 2),
    _createVNode("div", {
      class: ["opacity-25 fixed inset-0 z-20 bg-black", { 'z-40': _ctx.isOverlay }]
    }, null, 2)
  ], 64))
})